import HamburgerMenu from "./navigation-hamburger";
import Megamenu from "./navigation-megamenu";

export default class CustomNavigation {
	static init() {
		return new CustomNavigation();
	}

	constructor() {
		this.megamenu = Megamenu.init();
		this.hamburgerMenu = HamburgerMenu.init();
	}
}
